const OLD_SITE_PREFIX = "old";
const PREVIEW_PREFIX = "preview";
const STORAGE_PREFIX = "augmeditstorageweb";
const ROOT_DOMAIN = "lumi.cloud";

export default class CountryVerification {
  static isInCorrectCountry(countryCode) {
    const environment = this.getEnvironment();
    countryCode = countryCode?.toLowerCase() || "";
    return (
      this.isNonProduction(environment) ||
      countryCode === environment ||
      (countryCode === "" && environment == "prod")
    );
  }

  static getEnvironment() {
    let domainSplit = this.getHostname().split(".");
    if (domainSplit[0] === PREVIEW_PREFIX) domainSplit = domainSplit.slice(1);
    if (domainSplit[0] === OLD_SITE_PREFIX) domainSplit = domainSplit.slice(1);
    const domainStart = domainSplit[0];
    if (domainStart.startsWith(STORAGE_PREFIX))
      return domainStart.substring(STORAGE_PREFIX.length);
    if (domainSplit.join(".") === ROOT_DOMAIN || domainStart === "www")
      return "prod";
    return domainStart;
  }

  static isOldSite() {
    return this.getHostname().split(".")[0] === OLD_SITE_PREFIX;
  }

  static isUsSite() {
    // Make it possible to see the about box before deploying on us site
    const countryCodeOnUrl = new URL(location.href).searchParams.get(
      "countryCode"
    );

    return (
      countryCodeOnUrl === "us" || CountryVerification.getEnvironment() === "us"
    );
  }

  static isNonProduction(environment) {
    if (!environment) environment = this.getEnvironment();
    return (
      environment === "lab" ||
      environment === "acc" ||
      environment === "test" ||
      environment === "localhost"
    );
  }

  static getUrlForRegion(countryCode) {
    const isOldSite = this.isOldSite();
    const region = countryCode?.toLowerCase() || (isOldSite ? "" : "www");
    const domainName = [isOldSite ? OLD_SITE_PREFIX : "", region, ROOT_DOMAIN]
      .filter(Boolean)
      .join(".");
    return window.location.protocol + "//" + domainName;
  }

  static getHostname() {
    return (window.location.hostname || "").toLowerCase();
  }
}
